import { LegacyGeozoneType, TLegacyGeozone } from "../api/types/Geozone";
import {
  DISTANCE_UNITS,
  DISTANCE_UNITS_OPTIONS,
  DISTANCE_UNIT_VALUES,
} from "../pages/admin-details/account/constants";
import { TLatLng } from "../types/map";
import { accountDistanceUnit, convertMetersTo } from "./distance";
import { getGeozonePoints } from "./geozonePoints";

export const getGeozoneShapeTitle = (geozone: Partial<TLegacyGeozone>) => {
  switch (parseInt((geozone.zonetype || "").toString())) {
    case LegacyGeozoneType.ROUTE:
      return "Route"; // !!geozone.properties?.locs ? `${geozone.properties?.locs?.length} route points` : null;
    case LegacyGeozoneType.POLYGON:
      return "Polygon"; // !!geozone.properties?.locs ? `${geozone.properties?.locs?.length} polygon points` : null;
    case LegacyGeozoneType.CIRCLE:
    default:
      return "Circle"; // !!geozone.properties?.radius ? `Radius ${geozone.properties?.radius?.toFixed(2)}mi` : null;
  }
};

export const getGeozoneShapeDescription = (
  geozone: Partial<TLegacyGeozone>,
  unit_value: DISTANCE_UNIT_VALUES
) => {
  const activePoints = getGeozonePoints(
    geozone as Parameters<typeof getGeozonePoints>[0]
  );
  switch (parseInt((geozone.zonetype || "").toString())) {
    case LegacyGeozoneType.ROUTE:
      return !!activePoints.length
        ? `${activePoints?.length} route point${activePoints.length === 1 ? "" : "s"}`
        : null;
    case LegacyGeozoneType.POLYGON:
      return !!activePoints.length
        ? `${activePoints?.length} polygon point${activePoints.length === 1 ? "" : "s"}`
        : null;
    case LegacyGeozoneType.CIRCLE:
    default:
      const unit: DISTANCE_UNITS =
        DISTANCE_UNITS_OPTIONS.find((option) => option.value === unit_value)
          ?.unit || DISTANCE_UNITS_OPTIONS[0].unit;
      return !!geozone.radius
        ? `Radius ${convertMetersTo(unit, geozone.radius)?.toFixed(2).replace(".00", "")}${accountDistanceUnit(unit)}`
        : null;
  }
};

export const getGeozoneShapeCenter = (
  geozone: Partial<TLegacyGeozone>,
  returnFormat: "string" | "object" = "string"
) => {
  // TODO: needs fixing
  switch (parseInt((geozone.zonetype || "").toString())) {
    case LegacyGeozoneType.ROUTE:
    case LegacyGeozoneType.POLYGON:
      let maxLat = geozone?.maxlatitude || 0;
      let minLat = geozone?.minlatitude || 0;
      let maxLon = geozone?.maxlongitude || 0;
      let minLon = geozone?.minlongitude || 0;
      if (!maxLat && !minLat && !maxLon && !minLon) {
        // bulk-loaded zones can come without a stored bounding box
        const points = getGeozonePoints(
          geozone as Parameters<typeof getGeozonePoints>[0]
        );
        if (points.length > 0) {
          const lats = points.map((point) => point.latitude);
          const lons = points.map((point) => point.longitude);
          maxLat = Math.max(...lats);
          minLat = Math.min(...lats);
          maxLon = Math.max(...lons);
          minLon = Math.min(...lons);
        }
      }
      return returnFormat === "object"
        ? ({
            latitude: minLat + (maxLat - minLat) / 2,
            longitude: minLon + (maxLon - minLon) / 2,
          } as TLatLng)
        : `${(minLat + (maxLat - minLat) / 2).toFixed(6)}, ${(minLon + (maxLon - minLon) / 2).toFixed(6)}`;
    case LegacyGeozoneType.CIRCLE:
    default:
      return returnFormat === "object"
        ? ({
            latitude: geozone?.latitude1,
            longitude: geozone?.longitude1,
          } as TLatLng)
        : `${geozone?.latitude1}, ${geozone?.longitude1}`;
  }
};

export const geozoneDisplayName = (geozone: Partial<TLegacyGeozone>) => {
  return `${geozone?.geozoneid}${geozone?.description ? ` | ${geozone.description}` : ""}`;
};

// per client, white color geozones should be excluded from display on map screens
export const filterOutWhiteGeozones = (geozone: TLegacyGeozone) =>
  (geozone.shapecolor || "").toLowerCase() !== "#ffffff";
